import FJMobileImageManipulationEdit from './FJMobileImageManipulationEdit';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJUtil from '../../../util/FJUtil';
import FJActionImageManipulation from '../../../redux/action/FJActionImageManipulation';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useCallback } from 'react';
import {
    setSliceImageEnhancerDataAction,
    setSliceSwitchOldPhotoRestorationAction,
    setSliceSwitchPhotoColorizeAction,
} from '../../../redux/slices/FJSliceImageManipulation';
import { setSliceMobileCanDraw } from '../../../redux/slices/FJSliceBrushEditCommon';
const FJMobileImageManipulationEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const switchOldPhotoRestoration = useSelector(state => state.imageManipulation.switchOldPhotoRestoration);
    const switchPhotoColorize = useSelector(state => state.imageManipulation.switchPhotoColorize);
    const imageEnhancerData = useSelector(state => state.imageManipulation.imageEnhancerData);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const switchScratchOrFold = useSelector(state => state.imageManipulation.switchScratchOrFold);
    const photoColorizeNum = useSelector(state => state.imageManipulation.useNumFunctionData.photoColorize);
    const uploadImageInfo = useSelector(state => state.imageManipulation.uploadImageInfo);
    const imageEnhancerNum = useSelector(state => state.imageManipulation.useNumFunctionData.imageEnhancer);
    const changeSwitchScratchOrFold = useCallback(
        value => {
            dispatch(FJActionImageManipulation.setSliceSwitchScratchOrFoldAction(value));
        },
        [dispatch],
    );
    const uploadImg = useCallback(
        file => {
            dispatch(FJActionImageManipulation.uploadImageAction(file));
        },
        [dispatch],
    );
    const onSwitchOldPhotoRestoration = useCallback(
        value => {
            dispatch(setSliceSwitchOldPhotoRestorationAction(value));
        },
        [dispatch],
    );

    const onSwitchPhotoColorize = useCallback(
        value => {
            dispatch(setSliceSwitchPhotoColorizeAction(value));
        },
        [dispatch],
    );
    const onChangeImageEnhancerData = useCallback(
        value => {
            dispatch(setSliceImageEnhancerDataAction(value));
        },
        [dispatch],
    );
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageManipulation.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);
    const setIsCanDraw = useCallback(
        value => {
            dispatch(setSliceMobileCanDraw(value));
        },
        [dispatch],
    );
    return (
        <FJMobileImageManipulationEdit
            switchOldPhotoRestoration={switchOldPhotoRestoration}
            switchPhotoColorize={switchPhotoColorize}
            imageEnhancerData={imageEnhancerData}
            taskStatus={taskStatus}
            creditNumber={creditNumber}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            switchScratchOrFold={switchScratchOrFold}
            photoColorizeNum={photoColorizeNum}
            imageEnhancerNum={imageEnhancerNum}
            uploadImageInfo={uploadImageInfo}
            onSwitchOldPhotoRestoration={onSwitchOldPhotoRestoration}
            onSwitchPhotoColorize={onSwitchPhotoColorize}
            onGenerate={_onGenerate}
            uploadImg={uploadImg}
            changeSwitchScratchOrFold={changeSwitchScratchOrFold}
            onChangeImageEnhancerData={onChangeImageEnhancerData}
            setIsCanDraw={setIsCanDraw}
        />
    );
};

export default FJMobileImageManipulationEditContainer;
